import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';
import { color as evColor } from '@design/templateFns';

export const Status = ({
  size,
  color = evColor('gray2')(),
  x = '0px',
  y = '0px',
  scale = 0,
  embeddedIcon = 'success',
}: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '132px'}
      height={size || '132px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 132 132"
    >
      <clipPath id="lineclipper">
        <path
          id="clipper"
          d="M66,0C29.549,0,0,29.549,0,66s29.549,66,66,66s66-29.549,66-66S102.451,0,66,0z M66,117
          c-28.167,0-51-22.833-51-51s22.833-51,51-51s51,22.833,51,51S94.167,117,66,117z"
        />
      </clipPath>
      <g clipPath="url(#lineclipper)">
        <line fill="none" stroke={color} strokeWidth="1.5" x1="66" y1="132" x2="66" y2="0" />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(5 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(10 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(15 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(20 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(25 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(30 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(35 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(40 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(45 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(50 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(55 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(60 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(65 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(70 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(75 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(80 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(85 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(90 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(95 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(100 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(105 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(110 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(115 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(120 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(125 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(130 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(135 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(140 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(145 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(150 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(155 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(160 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(165 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(170 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(175 66 66)"
        />
        <line
          fill="none"
          stroke={color}
          strokeWidth="1.5"
          x1="66"
          y1="132"
          x2="66"
          y2="0"
          transform="rotate(180 66 66)"
        />
      </g>
      <circle fill={color} cx="66" cy="66" r="25" />

      {embeddedIcon === 'success' ? (
        <g className="embedded-icon__success">
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="4"
            d="M53.566,67.686l7.124,7.225l17.623-17.872"
          />
        </g>
      ) : embeddedIcon === 'error' ? (
        <g className="embedded-icon__error">
          <circle fill="#FFFFFF" cx="65.933" cy="79.166" r="3.931" />
          <polyline
            fill="#FFFFFF"
            points="69.064,48.853 68.714,72.971 62.886,72.971 62.535,48.853 		"
          />
        </g>
      ) : (
        <g className="embedded-icon__error">
          <circle fill="none" stroke="#FFFFFF" strokeWidth="4" cx="62.908" cy="63.455" r="6.5" />
          <path fill="none" stroke="#FFFFFF" strokeWidth="4" d="M75.408,75.955l-9-9" />
        </g>
      )}
    </StyledSvg>
  );
};
